import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const ConcelloInventarioBombeosSection = ({concello}) => {
    return (
        <SectionCard title="Bombeos">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(concello.stats.bombeos)}
                        tooltipText="Número de estacións de bombeo instaladas na rede"
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Potencia instalada:"
                        value={NumberUtil.formatDecimal(concello.stats.potenciabombeo)}
                        unit="Kw"
                        tooltipText="Potencia total de bombeo instalada na rede"
                    />
                    <SectionField
                        label="Consumo:"
                        value={NumberUtil.formatDecimal(
                            concello.stats.consumoelectricobombeo
                        )}
                        unit="Kwh/ano"
                        tooltipText="Consumo eléctrico anual dos bombeos instalados na rede"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default ConcelloInventarioBombeosSection;
